import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import CadastrarInsumoRecord from '@components/InsumoRecord/CadastrarInsumoRecord';
import formatMessage from './i18n/formatMessage';
import Insumo from '@resources/InsumosEnum';
import { withRouter } from 'react-router-dom';

/**
 * Tela para cadastro de inseticas
 *
 * @author Gabriela Farias <gabriela.farias@kepha.com.br>
 * @param {*} props
 * @returns {JSX.Element}
 */
function EditarInseticidas(props) {
  useEffect(() => {
    const title = 'inseticida.cadastroDeInseticida';
    if (props.itensState.name !== title) {
      props.dispatch({ type: 'UPDATE_TOOLBAR', toolbar: formatMessage(title), name: title });
    }
  }, []);

  return (
    <CadastrarInsumoRecord
      id={props.match.params.id}
      insumoURL={'inseticidas'}
      insumoEnum={Insumo.INSETICIDA}
      infoUsuario={props.infoUsuario}
      saveMessage={formatMessage(
        'inseticida.' +
          (props.match.params.id ? 'inseticidaEditadoComSucesso' : 'inseticidaCadastradoComSucesso')
      )}
      falhaSaveMesssage={formatMessage(
        'inseticida.' +
          (props.match.params.id ? 'falhaAoEditarInseticida' : 'falhaAoCadastrarInseticida')
      )}
      falhaCarregarMensagem={formatMessage('inseticida.falhaAoCarregarInseticida')}
    />
  );
}

const mapStateToProps = state => ({
  itensState: state.toolbar,
  infoUsuario: state.adicionarInfoUsuario.info
});

export default withRouter(connect(mapStateToProps)(EditarInseticidas));
